import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTheme} from '@mui/material/styles';
import {IconBox, Ic} from './IconBox';

export function CoverageExtensionRow({
  icon,
  title,
  description,
  price,
  recommended,
  checked,
  onToggle,
  last,
  children,
  testId,
  compact = false,
}) {
  const theme = useTheme();
  return (
    <div style={{borderBottom: last ? 'none' : `1px solid ${theme.palette.divider}`}}>
      <div
        role='checkbox'
        aria-checked={Boolean(checked)}
        tabIndex={0}
        data-testid={testId}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onToggle?.();
          }
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: compact ? 10 : 16,
          padding: compact ? '11px 2px' : '14px 4px',
          cursor: 'pointer',
        }}
      >
        <div style={{display: 'flex', alignItems: 'center', gap: compact ? 10 : 14, flex: '1 1 auto', justifyContent: 'flex-start'}}>
          <div style={{order: 2, textAlign: 'right'}}>
            <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8}}>
              <span style={{fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.pxToRem(compact ? 13.5 : 16), color: theme.palette.text.primary}}>
                {title}
                {!compact && (
                  <span style={{fontWeight: theme.typography.fontWeightBold, color: theme.palette.primary.dark}}>
                    <FormattedMessage id='coverage.extensionAverageCost' values={{price}}/>
                  </span>
                )}
              </span>
              {recommended && (
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 5,
                  background: theme.palette.success.light,
                  color: theme.palette.success.dark,
                  borderRadius: 9999,
                  padding: '3px 11px',
                  fontWeight: theme.typography.fontWeightBold,
                  fontSize: theme.typography.pxToRem(12),
                }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2z"/></svg>
                  {recommended}
                </span>
              )}
            </div>
            {compact && (
              <div
                data-testid={testId ? `${testId}-price` : undefined}
                style={{fontSize: theme.typography.pxToRem(12.5), fontWeight: theme.typography.fontWeightRegular, color: theme.palette.text.secondary, lineHeight: 1.5, marginTop: 2}}
              >
                <FormattedMessage id='coverage.extensionCompactCost' values={{price}}/>
              </div>
            )}
            {description && <div style={{fontSize: theme.typography.pxToRem(compact ? 11.5 : 13), color: theme.palette.text.secondary, lineHeight: 1.5, marginTop: 3}}>{description}</div>}
          </div>
          <span style={{order: 1}}>
            <IconBox icon={icon} size={compact ? 30 : 48} circular={compact} selected={checked} />
          </span>
        </div>
        <div style={{flex: 'none', display: 'flex', alignItems: 'center', gap: compact ? 10 : 16}}>
          <span
            aria-hidden='true'
            style={{
              width: compact ? 20 : 24,
              height: compact ? 20 : 24,
              flex: 'none',
              borderRadius: 4,
              border: `2px solid ${checked ? theme.palette.primary.main : theme.palette.divider}`,
              background: checked ? theme.palette.primary.main : theme.palette.background.paper,
              color: theme.palette.primary.contrastText,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 150ms ease-out, border-color 150ms ease-out',
            }}
          >
            {checked && <Ic name="check" size={16} />}
          </span>
        </div>
      </div>
      {checked && children && (
        <div onClick={(e) => e.stopPropagation()} style={{padding: '2px 4px 16px'}}>
          {children}
        </div>
      )}
    </div>
  );
}
